module.exports = __webpack_public_path__ + "img/4.c0352a81.png";